import { Tooltip as HeroTooltip } from "@heroui/react";
import React from "react";

interface TooltipProps {
    children: React.ReactNode;
    content: string | React.ReactNode;
    showArrow?: boolean;
    placement?: "top" | "bottom" | "left" | "right";
}

const Tooltip: React.FC<TooltipProps> = ({
    children,
    content,
    showArrow = true,
    placement = "top",
}) => {
    return (
        <HeroTooltip
            content={content}
            showArrow={showArrow}
            placement={placement}
        >
            {children}
        </HeroTooltip>
    );
};

export default Tooltip;
